<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">Transfer Game Management</a>
      <div class="collapse navbar-collapse">
          <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'transfer-game-setting', 'form']">&#43; Add Game</a>
      </div>
    </div>
  </nav>
  <hr/>
  <div class="row">
    <div class="col-12">
      <app-table #table></app-table>
    </div>
  </div>